import React from 'react';

import { translate } from '@vestahealthcare/common/i18n';
import { Patient, SelfDirectingContact } from '@vestahealthcare/common/models';
import { EMPTY } from '@vestahealthcare/common/utils/constants';

import { PhoneLink } from 'styleguide-v2';

import { DetailItem } from '../utils';

type Props = {
  contactInfo?: SelfDirectingContact;
  member: Patient;
};

export const MemberSelfDirectingDetail = ({ contactInfo, member }: Props) => (
  <>
    <DetailItem
      namespace="personalDetailsCard"
      label="selfDirecting"
      noMarginBottom={member.selfDirecting !== false}
    >
      {![null, undefined].includes(member.selfDirecting as any) &&
        translate(`global.${member.selfDirecting ? 'yes' : 'no'}`)}
    </DetailItem>
    {member.selfDirecting === false && (
      <DetailItem
        namespace="personalDetailsCard"
        label="proxyContact"
        noMarginBottom
      >
        {contactInfo?.firstName ? (
          <>
            <p className="no-margin">
              {`${contactInfo.firstName} ${contactInfo.lastName}`.trim()}{' '}
              <span className="size-xs">[{contactInfo.relationship}]</span>
            </p>
            {contactInfo.phoneNumber && (
              <PhoneLink
                compact
                hidePrimary
                phone={contactInfo.phoneNumber}
                type={contactInfo.phoneType}
              />
            )}
            <p className="no-margin">
              {translate(
                'personalDetails.personalDetailsCard.proxyContactInfoOnFile',
              )}
              {': '}
              {contactInfo.infoOnFile
                ? translate('global.yes')
                : translate('global.no')}
            </p>
          </>
        ) : (
          <>{EMPTY}</>
        )}
      </DetailItem>
    )}
  </>
);
